module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-Regular.9a0fa988.woff";